import { PlugZap } from 'lucide-react'

import { cn } from '@/lib/cn'

interface AvisoDesconectadoProps {
  /** Nome da fonte para o usuário — "Conta Azul", "HubSpot". */
  fonte: string
  /** O que precisa ser feito, vindo da API. */
  motivo: string
  /** ISO da coleta que gerou os números exibidos abaixo do aviso. */
  coletadoEm: string | null
  className?: string
}

const FORMATO = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

/**
 * `coletadoEm` vem de `new Date().toISOString()` no servidor — instante, não
 * data-only. Formatar no fuso do navegador é o certo aqui (a regra do
 * `parseLocalDate` vale para campos `@db.Date`, que não têm hora).
 */
function formatarColeta(iso: string | null): string | null {
  if (!iso) return null
  const data = new Date(iso)
  return Number.isNaN(data.getTime()) ? null : FORMATO.format(data)
}

/**
 * Faixa de "fonte desconectada" exibida ACIMA dos cards, que continuam
 * mostrando o último dado real. Esconder os números numa queda de credencial
 * apagaria informação que já tínhamos; mostrá-los sem rótulo faria o usuário
 * ler dado velho como atual. O aviso é o que separa os dois.
 */
export function AvisoDesconectado({ fonte, motivo, coletadoEm, className }: AvisoDesconectadoProps) {
  const coleta = formatarColeta(coletadoEm)

  return (
    <div
      role="status"
      className={cn(
        'border-warning/40 bg-warning/10 flex items-start gap-3 rounded-lg border px-4 py-3',
        className,
      )}
    >
      <PlugZap className="text-warning mt-0.5 h-5 w-5 shrink-0" aria-hidden />
      <div className="text-sm">
        <p className="text-foreground font-medium">
          {fonte} desconectado{coleta ? ` — números de ${coleta}` : ''}
        </p>
        {motivo ? (
          <p className="text-muted-foreground mt-0.5">
            {motivo.charAt(0).toUpperCase()}
            {motivo.slice(1)}.
          </p>
        ) : null}
      </div>
    </div>
  )
}
